export default __webpack_public_path__ + "static/media/Pranav.56ca56ff.jpeg";